import type { Props } from "react-select"
import Select from "react-select"

export function CustomSelect<Option, IsMulti extends boolean = false>(
  props: Props<Option, IsMulti>,
) {
  return <Select menuPortalTarget={document.body} {...props} />
}
